import allWallets from './helpers/allWallets'
import Connect from './Connect'
import Loading from './Loading'
import Login from './Login'
import Payment from './Payment'
import Sale from './Sale'
import Select from './Select'

let DePayWidgets = {
  Connect,
  Login,
  Payment,
  Sale,
  Select,
  Loading,
  allWallets,
}

export default DePayWidgets
